// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfflineDonateModal_modal__eFX04{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.OfflineDonateModal_container__R7miX{
    position: relative;
    width: 85%;
    max-width: 412px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.OfflineDonateModal_header__1Zg7s{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.OfflineDonateModal_close__rls9O{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.OfflineDonateModal_form__1rFPJ{
    height: calc(100% - 50px);
}
.OfflineDonateModal_formInputs__znMVw{
    height: calc(100% - 80px);
    overflow-y: auto;
    overflow-x: hidden;
}
.OfflineDonateModal_amountInput__lilWy{
    display: block !important;
    margin-top: 25px;
    margin-bottom: 15px;
}
.OfflineDonateModal_amountInput__lilWy input{
    width: calc(100% - 86px);
    font-family: 'Gotham Medium', serif;
    font-size: 22px;
    border: 6px solid #40798C66;
}
.OfflineDonateModal_amountInput__lilWy input:focus{
    border: 6px solid #40798C66;
}
.OfflineDonateModal_input__K84oc{
    display: block !important;
    margin-top: 20px;
}
.OfflineDonateModal_input__K84oc input{
    width: calc(100% - 44px);
}
.OfflineDonateModal_buttons__J-j8V{
    display: flex;
    margin-top: 35px;
}
.OfflineDonateModal_buttonsApiError__sx1wd{
    margin-top: 9px;
}
.OfflineDonateModal_button__cjwAR{
    width: 194px;
    padding-left: 50px;
    padding-right: 50px;
}
@media(max-width: 500px){
    .OfflineDonateModal_button__cjwAR{
        width: calc(50% - 6px);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/OfflineDonateModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.form{\n    height: calc(100% - 50px);\n}\n.formInputs{\n    height: calc(100% - 80px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.amountInput{\n    display: block !important;\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n.amountInput input{\n    width: calc(100% - 86px);\n    font-family: 'Gotham Medium', serif;\n    font-size: 22px;\n    border: 6px solid #40798C66;\n}\n.amountInput input:focus{\n    border: 6px solid #40798C66;\n}\n.input{\n    display: block !important;\n    margin-top: 20px;\n}\n.input input{\n    width: calc(100% - 44px);\n}\n.buttons{\n    display: flex;\n    margin-top: 35px;\n}\n.buttonsApiError{\n    margin-top: 9px;\n}\n.button{\n    width: 194px;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n@media(max-width: 500px){\n    .button{\n        width: calc(50% - 6px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OfflineDonateModal_modal__eFX04`,
	"container": `OfflineDonateModal_container__R7miX`,
	"header": `OfflineDonateModal_header__1Zg7s`,
	"close": `OfflineDonateModal_close__rls9O`,
	"form": `OfflineDonateModal_form__1rFPJ`,
	"formInputs": `OfflineDonateModal_formInputs__znMVw`,
	"amountInput": `OfflineDonateModal_amountInput__lilWy`,
	"input": `OfflineDonateModal_input__K84oc`,
	"buttons": `OfflineDonateModal_buttons__J-j8V`,
	"buttonsApiError": `OfflineDonateModal_buttonsApiError__sx1wd`,
	"button": `OfflineDonateModal_button__cjwAR`
};
export default ___CSS_LOADER_EXPORT___;
